import React, { useEffect, useState } from 'react';
import { IPublicClientApplication } from '@azure/msal-browser';
import { AppTheme } from '../types';
import ImportWizard from './import/ImportWizard';
import ImportJobCard from './import/ImportJobCard';
import ImportChecklistPanel from '../components/ImportChecklistPanel';
import { getImportJobs, ImportJob } from '../services/importService';

interface Props { pca: IPublicClientApplication; theme: AppTheme; }

export default function Import({ pca }: Props) {
  const [jobs, setJobs]         = useState<ImportJob[]>([]);
  const [showWizard, setShowWizard] = useState(false);
  const [checklistJob, setChecklistJob] = useState<ImportJob | null>(null);

  const reload = () => getImportJobs(pca).then(setJobs).catch(() => {});
  useEffect(() => { reload(); }, []); // eslint-disable-line

  return (
    <div className="page" style={{ maxWidth: 960 }}>
      <div className="page-header">
        <h2 style={{ margin: 0 }}>Import / Migration</h2>
        {!showWizard && (
          <button className="btn-primary" onClick={() => setShowWizard(true)}>+ New Import</button>
        )}
      </div>

      {showWizard && (
        <div className="card" style={{ padding: 20, marginBottom: 24 }}>
          <ImportWizard pca={pca} onDone={() => { setShowWizard(false); reload(); }} />
        </div>
      )}

      <h3 style={{ marginBottom: 12 }}>Recent Imports</h3>
      {jobs.length === 0 && <div style={{ color: 'var(--ink-4)' }}>No import jobs yet.</div>}
      {jobs.map(j => (
        <ImportJobCard key={j.dagrun_pm_importjobid} job={j} onViewChecklist={() => setChecklistJob(j)} />
      ))}

      {checklistJob && (
        <ImportChecklistPanel pca={pca} job={checklistJob} mode="modal" onClose={() => setChecklistJob(null)} />
      )}
    </div>
  );
}
